import { Center, Spinner, Text, VStack } from "@chakra-ui/react"
import React, { useCallback, useState } from "react"
import { AllPermissionsGroupsQueryVariables, useAllPermissionsGroupsQuery } from "../../graphql"
import { PermissionsGroupsList } from "./PermissionsGroupsList"

export const AllPermissionsGroups: React.FC = () => {
	const [pagination, setPagination] = useState<AllPermissionsGroupsQueryVariables["pagination"]>({ limit: 20, page: 1 })

	const [{ data, fetching, error }] = useAllPermissionsGroupsQuery({
		variables: { pagination },
	})

	const nextPage = useCallback(() => {
		if (fetching) return

		if (data?.allPermissionsGroups.hasNextPage) {
			setPagination((prev) => ({
				...prev,
				page: (prev.page || 0) + 1,
			}))
		}
	}, [data, fetching])

	return (
		<VStack w="full" maxW="2xl" align="stretch">
			{fetching && !data?.allPermissionsGroups ? (
				<Center w="full" py="4">
					<VStack w="full" color="grayscale.label">
						<Text fontSize="sm">Loading groups</Text>
						<Spinner size="sm" />
					</VStack>
				</Center>
			) : error ? (
				<Center py="4">
					<Text fontSize="sm" fontWeight="semibold" color="error.500">
						{error.message.replace("[GraphQL] ", "")}
					</Text>
				</Center>
			) : data?.allPermissionsGroups.permissionsGroups && data.allPermissionsGroups.permissionsGroups.length ? (
				<VStack w="full" align="stretch">
					<Text>
						Showing {data.allPermissionsGroups.permissionsGroups.length || 0} group
						{(data.allPermissionsGroups.permissionsGroups.length || 0) > 1 ? "s" : ""}
					</Text>

					<PermissionsGroupsList permissionsGroups={data.allPermissionsGroups.permissionsGroups} loadMore={nextPage} />

					{fetching && (
						<Center w="full" py="4">
							<VStack w="full" color="grayscale.label">
								<Text fontSize="sm">Loading more groups</Text>
								<Spinner size="sm" />
							</VStack>
						</Center>
					)}
				</VStack>
			) : (
				<Center py="4">
					<Text fontSize="sm" fontWeight="semibold" color="error.500">
						Couldn&apos;t find any groups.
					</Text>
				</Center>
			)}
		</VStack>
	)
}
